import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
import { defineStore } from 'pinia';
import { getFormattedPhone } from '~/core/utils/getFormattedPhone';
import { PD_URL } from '~/core/constants';
import { ProfileApi as AgreementApi } from '~/core/api';
import { pluralize } from '~/core/utils/pluralize';
import { appointmentDeclension, doctorDeclension, lpuDeclension, rateDeclension, readerDeclension, serviceDeclension } from '~/core/constants/wordForms';
import useSiteSettingsStore from '~/stores/useSiteSettingsStore';
import { AgreementStatus } from '~/features/Profile/enums';
import { ProfileApi } from '~/features/Profile/api';
import appointmentListApi from '~/features/Appointments/api/appointmentList.api';
import rateApi from '~/features/Rates/api/rate.api';
import profileApi from '~/features/Profile/api/profile.api';
import hitsApi from '~/features/Rates/api/hits.api';
export default defineStore('profile', function () {
  var siteSettingsStore = useSiteSettingsStore();
  var phone = ref('');
  var townConfirmed = ref(false);
  var town = ref('');
  var townKey = ref('');
  var townId = ref(-1);
  var email = ref('');
  var agreementStatus = ref(AgreementStatus.Default);
  var preventShowingAgreement = ref(false);
  var afterAgreementCallback = ref(null);
  var clubCard = ref(null);
  var unreadNotificationsCount = ref(0);
  var medcardActiveSessionsCount = ref(0);
  var allowReceiveNewsEmails = ref(true);
  var allowReceiveMedcardEmails = ref(true);
  var hasLoyaltyCards = ref(false);
  var isFemaleCalendarEnabled = ref(true);
  var informationBlock = ref(null);
  var country = ref(null);
  var composedTownObject = computed(function () {
    return {
      key: townKey.value,
      id: townId.value,
      name: town.value
    };
  });
  var formattedPhone = computed(function () {
    if (!phone.value) {
      return '';
    }
    if (country.value) {
      var _country$value = country.value,
        mask = _country$value.maskForInput,
        phoneCode = _country$value.phoneCode;
      return getFormattedPhone(phone.value, {
        mask: mask,
        phoneCode: phoneCode
      });
    }
    return getFormattedPhone(phone.value);
  });
  var pdUrl = computed(function () {
    var _country$value2;
    return (_country$value2 = country.value) !== null && _country$value2 !== void 0 && _country$value2.pdDomain ? "https://".concat(country.value.pdDomain) : PD_URL;
  });
  function setTown(data) {
    town.value = data.town;
    townKey.value = data.townKey;
    townId.value = data.townId;
  }
  function rulesAgree() {
    return _rulesAgree.apply(this, arguments);
  }
  function _rulesAgree() {
    _rulesAgree = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            agreementStatus.value = AgreementStatus.Agreed;
            afterAgreementCallback.value = null;
            _context.next = 4;
            return AgreementApi.rulesAgree();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _rulesAgree.apply(this, arguments);
  }
  function fetchProfile() {
    return _fetchProfile.apply(this, arguments);
  }
  function _fetchProfile() {
    _fetchProfile = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _infoResponse$data, _infoResponse$data2, _masterResponse$data;
      var _yield$Promise$all, _yield$Promise$all2, masterResponse, infoResponse;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([ProfileApi.getProfileFromMaster(), ProfileApi.getProfileFromInfo()]);
          case 2:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            masterResponse = _yield$Promise$all2[0];
            infoResponse = _yield$Promise$all2[1];
            hasLoyaltyCards.value = infoResponse.data.hasLoyaltyCards;
            isFemaleCalendarEnabled.value = infoResponse.data.isFemaleCalendarEnabled;
            email.value = infoResponse.data.email;
            allowReceiveNewsEmails.value = (_infoResponse$data = infoResponse.data) === null || _infoResponse$data === void 0 ? void 0 : _infoResponse$data.allowReceiveNewsEmails;
            allowReceiveMedcardEmails.value = (_infoResponse$data2 = infoResponse.data) === null || _infoResponse$data2 === void 0 ? void 0 : _infoResponse$data2.allowReceiveMedcardEmails;
            clubCard.value = (_masterResponse$data = masterResponse.data) === null || _masterResponse$data === void 0 ? void 0 : _masterResponse$data.clubCard;
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchProfile.apply(this, arguments);
  }
  function fetchProfileFromMaster() {
    return _fetchProfileFromMaster.apply(this, arguments);
  }
  function _fetchProfileFromMaster() {
    _fetchProfileFromMaster = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$ProfileApi$get, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return ProfileApi.getProfileFromMaster();
          case 2:
            _yield$ProfileApi$get = _context3.sent;
            data = _yield$ProfileApi$get.data;
            clubCard.value = data.clubCard;
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _fetchProfileFromMaster.apply(this, arguments);
  }
  function fetchInformationBlock() {
    return _fetchInformationBlock.apply(this, arguments);
  }
  function _fetchInformationBlock() {
    _fetchInformationBlock = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var doctorAppointmentsCount, serviceAppointmentsCount, doctorRatesCount, lpuRatesCount, savedMoney, allHits, newHits, _yield$Promise$all3, _yield$Promise$all4, appointmentsData, ratesData, profileData, hitsData;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            doctorAppointmentsCount = 0;
            serviceAppointmentsCount = 0;
            doctorRatesCount = 0;
            lpuRatesCount = 0;
            savedMoney = 0;
            allHits = 0;
            newHits = 0;
            _context4.prev = 7;
            _context4.next = 10;
            return Promise.all([appointmentListApi.getAppointmentsCount(), rateApi.getRatesCount(), siteSettingsStore.isAchievementsHidden ? Promise.resolve({
              data: {
                moneySavedByClub: 0
              }
            }) : profileApi.getSavedMoney(), hitsApi.getRatesHit()]);
          case 10:
            _yield$Promise$all3 = _context4.sent;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 4);
            appointmentsData = _yield$Promise$all4[0].data;
            ratesData = _yield$Promise$all4[1].data;
            profileData = _yield$Promise$all4[2].data;
            hitsData = _yield$Promise$all4[3].data;
            doctorAppointmentsCount = appointmentsData.doctorAppointmentsCount;
            serviceAppointmentsCount = appointmentsData.serviceAppointmentsCount;
            doctorRatesCount = ratesData.doctorRatesCount;
            lpuRatesCount = ratesData.lpuRatesCount;
            savedMoney = profileData.moneySavedByClub;
            allHits = (hitsData === null || hitsData === void 0 ? void 0 : hitsData.total.allHits) || 0;
            newHits = (hitsData === null || hitsData === void 0 ? void 0 : hitsData.total.newAllHits) || 0;
            _context4.next = 27;
            break;
          case 25:
            _context4.prev = 25;
            _context4.t0 = _context4["catch"](7);
          case 27:
            // NOTE: Не выбрасываем ошибку. Если что-то не удастся запросить, то просто покажем нули в данных

            informationBlock.value = {
              appointments: {
                totalCount: doctorAppointmentsCount + serviceAppointmentsCount,
                text: pluralize(doctorAppointmentsCount + serviceAppointmentsCount, appointmentDeclension, {
                  withValue: false
                }),
                doctors: pluralize(doctorAppointmentsCount, doctorDeclension, {
                  locale: true,
                  withValue: true
                }),
                services: pluralize(serviceAppointmentsCount, serviceDeclension, {
                  locale: true,
                  withValue: true
                })
              },
              rates: {
                totalCount: doctorRatesCount + lpuRatesCount,
                text: pluralize(doctorRatesCount + lpuRatesCount, rateDeclension, {
                  withValue: false
                }),
                doctors: pluralize(doctorRatesCount, doctorDeclension, {
                  locale: true,
                  withValue: true
                }),
                lpus: pluralize(lpuRatesCount, lpuDeclension, {
                  locale: true,
                  withValue: true
                })
              },
              savedMoney: savedMoney,
              hits: {
                newHits: newHits,
                allHits: allHits,
                text: pluralize(allHits, readerDeclension, {
                  withValue: false
                })
              }
            };
          case 28:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[7, 25]]);
    }));
    return _fetchInformationBlock.apply(this, arguments);
  }
  return {
    phone: phone,
    townConfirmed: townConfirmed,
    town: town,
    townKey: townKey,
    townId: townId,
    email: email,
    agreementStatus: agreementStatus,
    preventShowingAgreement: preventShowingAgreement,
    afterAgreementCallback: afterAgreementCallback,
    clubCard: clubCard,
    unreadNotificationsCount: unreadNotificationsCount,
    medcardActiveSessionsCount: medcardActiveSessionsCount,
    allowReceiveNewsEmails: allowReceiveNewsEmails,
    allowReceiveMedcardEmails: allowReceiveMedcardEmails,
    hasLoyaltyCards: hasLoyaltyCards,
    isFemaleCalendarEnabled: isFemaleCalendarEnabled,
    informationBlock: informationBlock,
    country: country,
    composedTownObject: composedTownObject,
    formattedPhone: formattedPhone,
    pdUrl: pdUrl,
    setTown: setTown,
    rulesAgree: rulesAgree,
    fetchProfile: fetchProfile,
    fetchInformationBlock: fetchInformationBlock,
    fetchProfileFromMaster: fetchProfileFromMaster
  };
});